import { connect } from 'react-redux';

import Modal from '../../components/comments/modal';

import { saveComment } from '../../actions/comments';
import { updateCommentField, cancelComment } from '../../actions/ui';

const mapStateToProps = function(state) {
	return {
		user: state.user,
		form: state.ui.dialog,
		allow_add: {
			public: state.features.add_public,
			course: state.features.add_course,
			feedback: state.features.add_feedback,
			private: state.features.add_private
		},
		visible: state.ui.dialog !== undefined
	};
}

const mapDispatchToProps = function(dispatch) {
	return {
		updateCommentField: (field, value)=>dispatch(updateCommentField(field, value)),
		saveComment: ()=>dispatch(saveComment()),
		cancelComment: ()=>dispatch(cancelComment())
	};
}

const ModalContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	undefined,
	{
		pure: true
	}
)(Modal)

export default ModalContainer;